<template>
  <div>
    <img v-if="mediaType === types.image" :src="mediaUrl" :alt="value.key" class="attachment"/>
    <video
      v-else-if="mediaType === types.video"
      controls
      preload="none"
      class="attachment"
    >
      <source :src="mediaUrl" :type="value.type">
      Sorry, your browser doesn't support embedded videos.
    </video>
    <audio
      v-else-if="mediaType === types.audio"
      :src="mediaUrl"
      controls
      preload="none"
      class="attachment"
    >
      Your browser does not support the audio element.
    </audio>
    <div v-else-if="mediaType === types.file" class="download-wrap">
      <IconCloudDownload class="download-icon"></IconCloudDownload>
      <button
        @click="onDownload"
        class="bot-action gray shadow download-btn"
      >
        {{ value.name }}
      </button>
    </div>
  </div>
</template>

<script>
  import IconCloudDownload from '@/components/icons/IconCloudDownload'
  export default {
    name: 'Media',
    components: { IconCloudDownload },
    props: {
      value: {
        type: Object,
        required: true,
      }
    },
    data: () => ({
      types: {
        unknown: 0,
        image: 1,
        video: 2,
        audio: 3,
        file: 4,
      },
    }),
    computed:{
      mediaType(){
        if(/^image/.test(this.value.type)){
          return this.types.image
        } else if (/^video/.test(this.value.type)){
          return this.types.video
        } else if (/^audio/.test(this.value.type)){
          return this.types.audio
        } else {
          return this.types.file
        }
      },
      mediaUrl(){
        return `//${window.location.hostname}/api/bot/media/${this.value.key}`
      }
    },
    methods:{
      onDownload(){
        window.open(this.mediaUrl, '_blank').focus()
      }
    }
  }
</script>

<style scoped>
  .attachment {
    max-width: 100%;
  }
  .download-wrap{
    position: relative;
  }
  .download-btn {
    vertical-align: middle;
    display: inline-block;
    line-height: 1.5;
    cursor: pointer;
    width: 100%;
    font-weight: 400;
    text-align: center;
    text-decoration: none;
    font-size: 1rem;
    padding: .375rem .75rem;
    text-transform: none;
  }
  .download-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 13px;
    left: 8px;
  }
</style>